import React from "react";

import {
  FieldContainer,
  RadioGroup,
  RadioItem,
  SubFieldContainer,
  CheckboxGroup,
  CheckboxItem,
  CustomSelect,
  Option,
  Label,
  Note,
} from "../../components/CustomFields";

import MoveHeroImage from "../../assets/images/Move_hero.png";

import InformWarper from "./InformWarper";

const timeList = [15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 100, 140, 180, 200];
export const exerciseTimeOptions = timeList.map((t, i) => ({
  value: t > 60 ? (t + timeList[i - 1]) / 2 : t,
  label:
    i === timeList.length - 1
      ? `${timeList[i - 1]} นาทีขึ้นไป`
      : t > 60
      ? `${timeList[i - 1] + 1}-${t} นาที`
      : i === 0
      ? `${t - 5}-${t} นาที`
      : `${t - 4}-${t} นาที`,
}));

const Excercise = ({ form = {} }) => {
  return (
    <InformWarper
      name="รักออกกำลัง"
      desc="วันละ อย่างน้อย 60 นาที"
      icon={MoveHeroImage}
      heroLabel="Move Hero ชวนศึกษา"
      leftButton="สูง ฟิต คิดเก่ง"
      rightButton="มูฟ อีซีย์ กัน"
      onLeftButtonClick={() => {
        window.open("/article/move?key=read");
      }}
      onRightButtonClick={() => {
        window.open("/article/move?key=think");
      }}
    >
      <Label>
        {`การออกกำลังในที่นี้หมายถึงการมีกิจกรรมทางกายคือเคลื่อนไหวร่างกายจนมีการใช้พลังงานพอสมควร สามารถจำแนกเป็น 3 หมวดกิจกรรมได้แก่
1. กิจกรรมทางกายในการทำงาน สำหรับสามเณรนั้น ก็คือการทำกิจกรรมที่พระสงฆ์มอบหมาย เช่น ปัดกวาดทำความสะอาด
2. กิจกรรมทางกายในการเดินทาง สำหรับสามเณรนั้น ก็คือ การเดินบิณฑบาต
3. กิจกรรมทางกายเพื่อนันทนาการ หรือกิจกรรมยามว่าง สำหรับสามเณรนั้น ก็คือ การออกกำลังกาย เดี่ยว หรือเป็นกลุ่มด้วยการออกกำลังกายหลากหลายประเภททั้งแบบแอโรบิก แบบสร้างกล้ามเนื้อ เช่น ยกน้ำหนัก แบบกระตุ้นกระดูก เช่น กระโดดเชือก หรือ แบบยืดเหยียด เช่น กายบริหาร

`}
      </Label>
      <FieldContainer
        name="haveExercised"
        label="เมื่อวานนี้ทั้งวัน ท่านได้ออกกำลังกาย รวมทั้งวันและทุกประเภท ได้กี่นาที เช่น เดินบิณฑบาต ขัดทำความสะอาด
บริเวณวัด หรือกิจกรรมอื่นๆ ที่ได้เคลื่อนไหวร่างกาย ตอบตัวเลขที่ใกล้เคียงที่สุด กะประมาณ"
      >
        <RadioGroup>
          <RadioItem value={false}>ไม่ได้ออกกำลัง</RadioItem>
          <RadioItem value={true}>ออกกำลังกาย</RadioItem>
        </RadioGroup>
      </FieldContainer>
      {form.haveExercised && (
        <SubFieldContainer>
          <FieldContainer name="exerciseTime" label="">
            <CustomSelect placeholder="โปรดระบุ" allowClear>
              {exerciseTimeOptions.map((opt) => (
                <Option value={opt.value}>{opt.label}</Option>
              ))}
            </CustomSelect>
          </FieldContainer>
        </SubFieldContainer>
      )}
    </InformWarper>
  );
};

export default Excercise;
